import { Container } from '../../components';
import Why1 from '../../public/mvp/why1.svg';
import Why2 from '../../public/mvp/why2.svg';
import Why3 from '../../public/mvp/why3.svg';
import Why4 from '../../public/mvp/why4.svg';
import MvpCard from './mvp-card';
import styles from './mvp-why.module.css';
import commonStyles from './mvp.module.css';

const cards = [
  {
    id: 1,
    icon: <Why1 className={styles.icon} />,
    title: 'Native Stack Only',
    description:
      'We build your MVP using modern, native technologies. This ensures high performance, full scalability, and clean, maintainable code from day one. No shortcuts, no hybrid frameworks.',
  },
  {
    id: 2,
    icon: <Why2 className={styles.icon} />,
    title: 'Based in Europe',
    description:
      'Our team is based in Poland and Ukraine — combining high technical standards with excellent communication and time zone alignment for both EU and US clients. We speak your language and work when you do.',
  },
  {
    id: 3,
    icon: <Why3 className={styles.icon} />,
    title: 'MVPs from $7k',
    description:
      'We’re startup-friendly — our pricing starts from just $7,000 for a full MVP package, including design, development, and QA. Transparent, fixed pricing lets you budget with confidence and avoid surprises.',
  },
  {
    id: 4,
    icon: <Why4 className={styles.icon} />,
    title: 'Weekly Demos, Fixed Timeline',
    description:
      'You’ll get progress updates every single week. We keep you in the loop with live demos, fast feedback cycles, and a clearly defined delivery schedule. The result? A smooth, predictable launch in just 6 weeks.',
  },
];

export default function MVPWhy() {
  return (
    <section className={styles.why}>
      <Container>
        <div className={styles.content}>
          <h2 className={commonStyles.h2} id="why-us">
            WHY CHOOSE US
          </h2>
          <p className={commonStyles.text}>
            We don’t just build MVPs — we build them fast, clean, and right from the start. Our team combines deep technical expertise, AI-assisted development, and startup speed to help you launch a high-quality product in just 6 weeks. We use modern tools and proven processes to move faster without compromising quality. No shortcuts. No guesswork. Just real progress, delivered on time.
          </p>
        </div>
        <ul className={styles.list}>
          {cards.map((card) => (
            <li key={card.id} className={styles.item}>
              <MvpCard className={styles.card}>
                <div className={styles.card_wrapper}>
                  {card.icon}
                  <h3 className={styles.card_title}>{card.title}</h3>
                  <p className={styles.card_text}>{card.description}</p>
                </div>
              </MvpCard>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
